{
  "app_name": "Impact Golf",
  "app_banner_copy": "Play smoother with the mobile app",
  "app_banner_install": "Install",
  "app_banner_dismiss": "Dismiss",
  "app_profile_row": "Download the mobile app",
  "app_store_ios": "App Store",
  "app_store_android": "Google Play",
  "app_platform_ios": "iPhone",
  "app_platform_android": "Android"
}
